module.exports = __webpack_public_path__ + "img/template-2.299ff8fd.webp";